var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_713_64",
    "data-name": "Component 713 \\u2013 64",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8627",
    "data-name": "Rectangle 8627",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24469",
    "data-name": "Group 24469",
    transform: "translate(1.895 1.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(0.105 0.105)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24189",
    "data-name": "Group 24189",
    transform: "translate(3.628 1.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M3.815-5.281H2.683v-.578a2.449,2.449,0,0,1,.06-.566,1.777,1.777,0,0,1,.175-.458,2.316,2.316,0,0,1,.277-.391q.163-.187.367-.379l.446-.422a2.327,2.327,0,0,0,.44-.5,1.257,1.257,0,0,0,.175-.693,1.2,1.2,0,0,0-.367-.921,1.329,1.329,0,0,0-.945-.343,1.258,1.258,0,0,0-.964.385,1.585,1.585,0,0,0-.422.939L.768-9.34a2.686,2.686,0,0,1,.3-.933,2.464,2.464,0,0,1,.572-.7,2.408,2.408,0,0,1,.789-.44,2.953,2.953,0,0,1,.951-.151,3.009,3.009,0,0,1,.945.145A2.324,2.324,0,0,1,5.1-11a1.993,1.993,0,0,1,.53.7,2.253,2.253,0,0,1,.193.958,2.419,2.419,0,0,1-.084.674,2,2,0,0,1-.235.524,2.348,2.348,0,0,1-.367.44q-.217.2-.47.422t-.409.367A1.5,1.5,0,0,0,4-6.582a1.259,1.259,0,0,0-.139.373,2.561,2.561,0,0,0-.042.506Zm.3,1.7a.781.781,0,0,1-.229.554.763.763,0,0,1-.578.241.779.779,0,0,1-.572-.235A.751.751,0,0,1,2.5-3.571a.775.775,0,0,1,.229-.56.773.773,0,0,1,.578-.235.784.784,0,0,1,.578.229A.755.755,0,0,1,4.116-3.583Z",
    transform: "translate(-0.768 11.568)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOutline);
export default __webpack_public_path__ + "static/media/question-outline.4d712129.svg";
export { ForwardRef as ReactComponent };